<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>直播课程</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search">

      <el-form-item label="分类">
        <el-select size="small" v-model="type1" @change="selectOption1()" placeholder="请选择">
          <el-option v-for="type in typeArr1" :label="type.title" :value="type.id" :key="type.id"></el-option>
        </el-select>
      </el-form-item>





      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search"
          @click="getCourseClassifyList(this.type3)">查询</el-button>
      </el-form-item>

      <el-form-item label="">

        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>

      <el-table-column sortable prop="title" label="标题" width="200">
      </el-table-column>

      <!-- <el-table-column sortable prop="introduce" label="介绍" width="200">
      </el-table-column> -->


      <el-table-column sortable prop="courseUrl" label="跳转地址" width="200">
      </el-table-column>

      <el-table-column sortable prop="platformName" label="平台名称" width="120">
        <template slot-scope="scope">
          <div>{{ scope.row.platformName || formatPlatformType(scope.row.platformType) }}</div>
        </template>
      </el-table-column>

      <el-table-column sortable prop="platformType" label="平台类型" width="140">
        <template slot-scope="scope">
          <div>{{ formatPlatformType(scope.row.platformType) }}</div>
        </template>
      </el-table-column>

      <el-table-column sortable prop="jumpType" label="跳转方式" width="120">
        <template slot-scope="scope">
          <div>{{ formatJumpType(scope.row.jumpType) }}</div>
        </template>
      </el-table-column>

      

      <el-table-column prop="name" label="封面图" width="120">

        <template slot-scope="scope">
          <img style="width: 90px;height: 90px;" :src="scope.row.coverPlan">
        </template>

      </el-table-column>



      <el-table-column sortable prop="createTime" label="创建时间" width="150">
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>


      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">


          <!-- <el-button size="mini" @click="handleEditIsData(scope.$index, scope.row)">资料管理</el-button> -->
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteCourse(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" ref="editForm">
        <el-form-item label="标题" prop="deptName">
          <el-input size="small" v-model="formData.title" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="跳转地址" prop="deptName">
          <el-input size="small" v-model="formData.courseUrl" auto-complete="off" placeholder="请输入跳转地址"></el-input>
        </el-form-item>
        <el-form-item label="平台类型">
          <el-select size="small" v-model="formData.platformType" @change="handlePlatformTypeChange" placeholder="请选择平台类型" style="width: 100%">
            <el-option v-for="item in platformTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台名称">
          <el-input size="small" v-model="formData.platformName" auto-complete="off" placeholder="例如：腾讯会议、抖音直播"></el-input>
        </el-form-item>
        <el-form-item label="跳转方式">
          <el-select size="small" v-model="formData.jumpType" placeholder="请选择跳转方式" style="width: 100%">
            <el-option v-for="item in jumpTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="封面图" style="">

          <div class="upload-demo">
            <el-upload action="" :http-request="mainImgUpload" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
            <img v-if="formData.coverPlan" :src="formData.coverPlan" class="avatar">

          </div>

        </el-form-item>




      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="addCourse()"
          v-if="title == '添加'">添加</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="upCourse()"
          v-if="title == '修改'">修改</el-button>
      </div>
    </el-dialog>










    <el-dialog title="资料管理" :visible.sync="isData" width="50%" :close-on-click-modal="false"
      @click='closeDialog("edit")'>
      <el-table size="small" :data="courseDataList" highlight-current-row v-loading="loading" title="" border
        element-loading-text="拼命加载中" style="width: 100%;">

        <el-table-column prop="id" label="id" width="60"></el-table-column>
        <el-table-column prop="name" label="资料名称" width="200"></el-table-column>

        <el-table-column prop="name" label="封面图" width="120">

<template slot-scope="scope">
  <img style="width: 90px;height: 90px;" :src="scope.row.coverPlan">
</template>

</el-table-column>


        <el-table-column prop="createTime" label="创建时间" width="200">
          <template slot-scope="scope">
            <div>{{ transformDate(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column sortable prop="editUser" label="修改人" width="300">
       </el-table-column> -->
        <el-table-column align="center" label="操作" min-width="300">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click='deleteAccessory(scope.row)'>删除</el-button>
            <el-button size="mini" type="success" @click="openFile(scope.row.fileUrl)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-form :inline="true" :model="formInline">


        <el-form-item>




          <!-- <el-upload class="upload-demo" :action="accessoryAction" :on-preview="handlePreview" :on-remove="handleRemove"
            :before-remove="beforeRemove" multiple :limit="3" :on-exceed="handleExceed" :on-success="accessoryfileSuccess"
            :on-change="accessoryfileChange" :file-list="fileList">

            <el-button size="small" type="primary" icon="el-icon-upload2">上传</el-button>


          </el-upload> -->

          <el-button size="small" type="primary"  class="title" @click="editFormVisibleCourseData=true">添加</el-button>
          
        </el-form-item>




      </el-form>
    </el-dialog>







    <!-- 编辑界面 -->
    <el-dialog title="添加资料" :visible.sync="editFormVisibleCourseData" width="30%" @click="closeDialog">
      <el-form label-width="120px" ref="editForm">
        <el-form-item label="名称" prop="deptName">
          <el-input size="small" v-model="courseData.name" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>


        <el-form-item label="封面图" style="">

          <div class="upload-demo">
            <el-upload action="" :http-request="mainImgUpload1" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
            <img v-if="courseData.coverPlan" :src="courseData.coverPlan" class="avatar">

          </div>

        </el-form-item>

        <el-form-item label="上传文件" style="">

          <el-upload class="upload-demo" :action="accessoryAction" :on-preview="handlePreview" :on-remove="handleRemove"
            :before-remove="beforeRemove" multiple :limit="3" :on-exceed="handleExceed" :on-success="accessoryfileSuccess"
            :on-change="accessoryfileChange" :file-list="fileList">

            <el-button size="small" type="primary" icon="el-icon-upload2">上传</el-button>


          </el-upload>

        </el-form-item>

        





      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="addCourseData()">添加</el-button>
      </div>
    </el-dialog>





  </div>
</template>

<script>
import {



  getCourseClassifyList,


  addCourseData,
  deleteCourseData,
  getCourseClassifyDataList,
  
  addCourse,
  upCourse,
  deleteCourse,
  getCourseList,

} from "../../api/userMG";
import Pagination from "../../components/Pagination";
import client from "@/utils/ossClient.js";
export default {
  data() {
    return {


      isData:false,






      type1: 0,
      typeArr1: [],




      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",

      listData: [], //
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10,
      },


      formData: {
        coverPlan: "",//封面图
        title: "",//标题     
        introduce: "",//介绍   
        difficultyLevel: "",//难度等级   
        superiorId: 0,//上级ID   
        level: 0,//分类等级     
        type: 2,// 0课程分类，1直播分类，2vip分类  
        titleOne: "",//二级标题     
        introduceOne: "",//二级介绍  
        courseUrl:"",//跳转地址
        platformType: "external_h5",
        platformName: "网页直播",
        jumpType: "webview"

      },
      platformTypeOptions: [
        { label: "视频号", value: "wechat_video" },
        { label: "腾讯会议", value: "tencent_meeting" },
        { label: "抖音", value: "douyin" },
        { label: "快手", value: "kuaishou" },
        { label: "B站", value: "bilibili" },
        { label: "小鹅通", value: "xiaoe" },
        { label: "网页直播", value: "external_h5" },
        { label: "其他", value: "other" },
      ],
      jumpTypeOptions: [
        { label: "复制链接", value: "copy" },
        { label: "小程序内打开", value: "mini" },
        { label: "WebView", value: "webview" },
        { label: "海报引导", value: "poster" },
      ],

      courseDataList:[],//课程资料
      editFormVisibleCourseData: false, //控制编辑页面显示与隐藏
      courseData: {
        name: "",//名称
        coverPlan: "",//封面图     
        courseClassifyId: "",//课程分类资料ID
        courseId: 0,//资料ID
        type: "",// 资料类型      
       
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {


    this.getSuperiorCourseClassifyList(0, 0)

  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    selectOption1() {


      this.getCourseList()

    },


    // 按等级获取数据
    getSuperiorCourseClassifyList() {
      this.loading = true;

      getCourseClassifyList({ type: 1, superiorId: 0 }).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = []
            //选择的第一级
            this.typeArr1 = res.data.list;
            this.type1 = this.typeArr1[0].id;


            this.getCourseList()

        } else {




        }

      });
    },









    // 删除
    deleteCourse(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteCourse({ id: row.id })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "已删除！",
                });
                this.getCourseList(this.type1);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //修改
    upCourse() {

      this.loading = true;
      this.formData.difficultyLevel = 1;
      this.formData.classifyId = this.type1;
      this.formData.type = 1;
      if (!this.formData.platformName) {
        this.formData.platformName = this.getPlatformLabel(this.formData.platformType);
      }

        
      var formData = JSON.parse(JSON.stringify(this.formData));


      upCourse(formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisible = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getCourseList(this.type1);
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    //添加
    addCourse () {

      this.loading = true;
      this.formData.difficultyLevel = 1;
      this.formData.classifyId = this.type1;
      this.formData.type = 1;
      if (!this.formData.platformName) {
        this.formData.platformName = this.getPlatformLabel(this.formData.platformType);
      }

      var formData = JSON.parse(JSON.stringify(this.formData))


      addCourse(formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisible = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getCourseList(this.type1);
        } else {
          this.$message.error(res.msg);
        }
      });
    },


    //添加课程资料
    addCourseData() {


      var formData = JSON.parse(JSON.stringify(this.courseData))




      addCourseData(formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisibleCourseData = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.courseData.name = "";
          this.getCourseClassifyDataList(this.courseData.courseClassifyId)
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    


    //自定义上传方法..
    mainImgUpload(file) {

      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      // const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      // if (names.indexOf(exname) < 0) {
      //   this.$message.error("不支持的格式!");
      //   return;
      // }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
          if (res.url) {
            this.formData.coverPlan = res.url;
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => { });
    },

    //自定义上传方法..
    mainImgUpload1(file) {

      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      // const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      // if (names.indexOf(exname) < 0) {
      //   this.$message.error("不支持的格式!");
      //   return;
      // }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
          if (res.url) {
            this.courseData.coverPlan = res.url;
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => { });
    },


    // 获取
    getCourseList() {
      this.loading = true;

      getCourseList({ type: 1, classifyId: this.type1 }).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = res.data.list;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },
    getPlatformLabel(value) {
      const target = this.platformTypeOptions.find(item => item.value === value);
      return target ? target.label : "";
    },
    getDefaultJumpTypeByPlatform(value) {
      if (value === "external_h5") {
        return "webview";
      }
      return "copy";
    },
    handlePlatformTypeChange(value) {
      this.formData.platformName = this.getPlatformLabel(value);
      this.formData.jumpType = this.getDefaultJumpTypeByPlatform(value);
    },
    formatPlatformType(value) {
      return this.getPlatformLabel(value) || "未设置";
    },
    formatJumpType(value) {
      const target = this.jumpTypeOptions.find(item => item.value === value);
      return target ? target.label : "未设置";
    },









    //显示编辑界面
    handleEditIsData: function (index, row) {
      this.isData = true;
      this.courseData.courseClassifyId = row.id;


      this.getCourseClassifyDataList(row.id)
    },
    // 获取资料数据列表
    getCourseClassifyDataList(courseClassifyId) {
      this.loading = true;

      getCourseClassifyDataList({ type: 2, courseClassifyId: courseClassifyId }).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.courseDataList = res.data.list;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },









    // 分页插件事件
    callFather(parm) {
      this.getDishesList(parm.currentPage);
    },

    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.formData.id = row.id;
        this.formData.coverPlan = row.coverPlan;
        this.formData.courseUrl = row.courseUrl;
        this.formData.platformType = row.platformType || "external_h5";
        this.formData.platformName = row.platformName || "";
        this.formData.jumpType = row.jumpType || "copy";
        this.formData.introduce = row.introduce;
        this.formData.title = row.title;
        this.formData.introduceOne = row.introduceOne;
        this.formData.titleOne = row.titleOne;
        this.formData.difficultyLevel = row.difficultyLevel;





      } else {
        this.title = "添加";
        this.formData.id = "";
        this.formData.coverPlan = "";
        this.formData.introduce = "";
        this.formData.title = "";
        this.formData.introduceOne = "";
        this.formData.titleOne = "";
        this.formData.difficultyLevel = 1;
        this.formData.classifyId = this.type1;
        this.formData.type = 1;
        this.formData.courseUrl ="";
        this.formData.platformType = "external_h5";
        this.formData.platformName = this.getPlatformLabel("external_h5");
        this.formData.jumpType = this.getDefaultJumpTypeByPlatform("external_h5");
        




      }
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

.upload-demo {
  display: flex;
  flex-direction: row;
}

.upload-demo img {
  width: 140px;
  height: 140px;
}
</style>

 
 



// WEBPACK FOOTER //
// src/views/liveCourse/LiveCourse.vue